document.addEventListener('click', function(e){

  const btn =
    e.target.closest('.nf-grid-btn');

  if(!btn) return;

  const grid =
    document.querySelector('#product-grid');

  if(!grid) return;

  document
    .querySelectorAll('.nf-grid-btn')
    .forEach(b=>b.classList.remove('active'));

  btn.classList.add('active');

  const cols =
    btn.dataset.grid;

  grid.style.gridTemplateColumns =
    `repeat(${cols}, minmax(0,1fr))`;

});